module.exports = __webpack_public_path__ + "img/Visa.eeb4b02a.svg";